export default () => ({
  "departments": [],
  "orderSummary": null,
  "loading": false,
  "errors": {
    "applicationError": {
      "hasError": null,
      "error": []
    },
    "configurationError": {
      "hasError": null,
      "error": []
    },
    "maintenanceError": {
      "hasError": null,
      "error": ""
    }
  },
  "estoreConfiguration": {
    "required": false,
    "configuration": null
  },
  "formdata": {
    "requestorInformation": {},
    "requestDetails": {},
    "confirmation": {}
  },
  "confirmationNumber": null
});